import { ReactNode } from 'react';
import { AppSidebar } from '@/components/layout/app-sidebar';
import { Breadcrumbs } from '@/components/layout/breadcrumbs';
import { OrganizationAddressHealthBanner } from '@/components/layout/organization-address-health-banner';
import { SidebarProvider } from '@/components/ui/sidebar';

type LayoutProps = {
  children: ReactNode;
};

export function Layout({ children }: LayoutProps) {
  return (
    <SidebarProvider open>
      <div className="relative flex h-screen w-full overflow-hidden">
        <AppSidebar />
        <div className="relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          <OrganizationAddressHealthBanner />
          <header className="relative z-10 h-14 shrink-0 border-b px-6 flex items-center bg-background">
            <Breadcrumbs />
          </header>
          <main className="relative z-10 flex-1 overflow-auto bg-muted">
            <div className="h-full w-full">{children}</div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
